import { SVGProps } from "react";

const STIDisqus = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Disqus" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path fill="#2e9fff" d="M83 387l26-65a159 159 0 1142 56zm168-52q90-6 90 -81t-89-80h-61v161zm2-39h-18v-82h18q43 2 43 40t-43 42" /></svg>;

export { STIDisqus };